import swal from 'sweetalert2'
import '../sweetAlert2.css';

const SuccessAlert = (message) => {
    swal.fire({
        toast: true,
        type: 'success',
        timer: 3000,
        // width: '500px',
        position: 'top-end',
        animation: true,
        background: '#67c618',
        showConfirmButton: false,
        showCloseButton: true,
        title: message,
    })
}

export default SuccessAlert;